<template>
  <v-layout wrap align-center style="width: 100%; margin: 0">
    <v-flex :class="[showClear ? 'xs5' : 'xs6']">
      <date-picker
        :customLabel="customDateFromLabel"
        :gtDateString="dateFrom"
        :rangeStart="selectableRangeStart"
        :rangeEnd="selectableRangeEnd"
        :disabled="disabled"
        @onDateSelected="onDateFromSelected"
        :outlined="outlined"
        hide-details
        :first-day-of-week="firstDayOfWeek"
        :dense="dense"
      ></date-picker>
    </v-flex>
    <v-flex :class="[showClear ? 'xs5' : 'xs6', 'pl-1']">
      <date-picker
        :customLabel="customDateToLabel"
        :rangeStart="selectableRangeStart"
        :rangeEnd="selectableRangeEnd"
        :gtDateString="dateTo"
        :disabled="disabled"
        @onDateSelected="onDateToSelected"
        :outlined="outlined"
        :first-day-of-week="firstDayOfWeek"
        hide-details
        :dense="dense"
      ></date-picker>
    </v-flex>
    <v-flex v-if="showClear">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon small class="mx-0" @click="clearRange">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Clear Range</span>
      </v-tooltip>
    </v-flex>
    <div v-if="debug">
      <code>
        selctable range start: {{ selectableRangeStart }} - end :
        {{ selectableRangeEnd }}
      </code>
      <code>range start: {{ rangeStart }} - end : {{ rangeEnd }}</code>
    </div>
  </v-layout>
</template>

<script>
import DatePicker from "./DatePicker";

const moment = require("moment");

export default {
  name: "DatesRangePicker",

  components: {
    DatePicker,
  },

  props: {
    gtDateFromString: {
      type: String,
      default: "",
    },
    gtDateToString: {
      type: String,
      default: "",
    },
    customDateFromLabel: {
      type: String,
      default: "From",
    },
    customDateToLabel: {
      type: String,
      default: "To",
    },
    rangeStart: {
      type: String,
      default: moment().subtract(5, "years").toISOString(true),
    },
    rangeEnd: {
      type: String,
      default: () => moment().add(10, "years").toISOString(true),
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    firstDayOfWeek: {
      type: Number,
      default: () => 1,
    },
    autoEnd: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      dateFrom: this.gtDateFromString,
      dateTo: this.gtDateToString,
      clearDateFrom: false,
      clearDateTo: false,
      selectableRangeStart: this.rangeStart,
      selectableRangeEnd: this.rangeEnd,
    };
  },

  computed: {
    showClear() {
      return this.clearable && this.dateTo !== "" && this.dateFrom !== "";
    },
  },

  methods: {
    onDateFromSelected(data) {
      this.dateFrom = data;
      if (moment(this.dateFrom) > moment(this.dateTo)) {
        this.dateTo = this.dateFrom;
      }
      if (this.dateTo == "" && this.autoEnd) {
        this.dateTo = moment(this.dateFrom).add(1, "year").toISOString(true);
      }
      this.onRangeSelected("from");
    },
    onDateToSelected(data) {
      this.dateTo = data;
      if (moment(this.dateTo) < moment(this.dateFrom)) {
        this.dateFrom = this.dateTo;
      }
      this.onRangeSelected("to");
    },
    onRangeSelected(source = "from") {
      if (
        this.dateFrom &&
        this.dateFrom != "" &&
        this.dateTo &&
        this.dateTo != ""
      ) {
        this.$emit("onRangeSelected", {
          dateFrom: this.dateFrom.split("T")[0],
          dateTo: this.dateTo.split("T")[0],
          source,
        });
      }
      this.$emit("input", {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      });
    },
    clearRange() {
      this.dateTo = "";
      this.dateFrom = "";
      this.$emit("onClear");
    },
  },
  watch: {
    gtDateFromString(newVal) {
      if (newVal != "") {
        this.dateFrom = newVal;
      } else {
        this.dateFrom = "";
      }
    },
    gtDateToString(newVal) {
      if (newVal != "") {
        this.dateTo = newVal;
      } else {
        this.dateTo = "";
      }
    },
    rangeStart(newRangeStart) {
      //console.log("new range start", newRangeStart);
      this.selectableRangeStart = newRangeStart;
    },
    rangeEnd(newRangeEnd) {
      this.selectableRangeEnd = newRangeEnd;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/DatesRangePicker.vue